<!-- 三方导入Tab页 -->
<template>
  <!-- 顶部标签切换，展示不同设备类型 -->
  <el-tabs
    v-model="activeTabName"
    v-loading="isLoading"
    style="height: 100%"
    @tab-change="getTheRecordList"
  >
    <template v-for="tab in tabList" :key="tab.type">
      <el-tab-pane v-if="tab.condition" :name="tab.type">
        <template #label>
          <h3
            class="text text-normal"
            style="margin-right: 8px"
            :style="{
              fontWeight: tab.type == activeTabName ? 600 : 500,
              color: tab.type == activeTabName ? '#323233' : '#646566'
            }"
          >
            {{ tab.label }}
          </h3>
          <el-tag color="#248DF5" round size="small">
            <span style="color: #fff">{{ tab.recordCount }}</span>
          </el-tag>
        </template>
        <!-- 设备折叠列表 -->
        <div
          v-if="tab.list.length"
          class="device-list"
          :style="{ 'max-height': isMobile() ? '100%' : '320px' }"
        >
          <section v-for="device in tab.list" :key="device.deviceNo" class="device-panel">
            <button
              :aria-expanded="isDevicePanelOpen(tab.type, device.deviceNo)"
              class="device-panel__header"
              type="button"
              @click="toggleDevicePanel(tab.type, device.deviceNo)"
            >
              <div class="device-panel__info">
                <div class="device-panel__title">
                  <span class="device-panel__label">设备 ID：{{ device.deviceNo }}</span>
                  <span
                    class="device-panel__battery"
                    :class="{ 'is-low': isLowBattery(device.remainPower) }"
                  >
                    <i
                      class="t-iconfont"
                      :class="
                        isLowBattery(device.remainPower)
                          ? 'icon-battery-low-line'
                          : 'icon-battery-line1'
                      "
                    ></i>
                    {{ formatBatteryLevel(device.remainPower) }}
                    <i
                      class="t-iconfont"
                      :class="
                        isDevicePanelOpen(tab.type, device.deviceNo)
                          ? 'icon-arrow-down-s-line'
                          : 'icon-arrow-up-s-line'
                      "
                      style="margin-left: 8px"
                    ></i>
                  </span>
                </div>
                <p v-if="device.fileNum" class="device-panel__pending">
                  <span v-if="isMedicalIndustry"
                    >该设备还有 {{ device.fileNum }} 个拜访正在同步中...</span
                  >
                  <span v-else>该设备还有 {{ device.fileNum }} 个录音待上传</span>
                </p>
              </div>
            </button>
            <div
              :aria-hidden="!isDevicePanelOpen(tab.type, device.deviceNo)"
              class="device-panel__body"
              :class="{ 'is-open': isDevicePanelOpen(tab.type, device.deviceNo) }"
            >
              <div class="device-panel__body-inner">
                <!-- 录音列表 -->
                <ul v-if="device.recordList?.length" class="record-list">
                  <li
                    v-for="item in device.recordList"
                    :key="item.id"
                    class="record-item"
                    :class="{ 'record-item--medical': isMedicalIndustry }"
                  >
                    <!-- 医疗行业特殊样式 -->
                    <template v-if="isMedicalIndustry">
                      <!-- 隐藏的音频播放器，用于获取时长 -->
                      <div style="display: none">
                        <AudioPlayer
                          :ref="(el) => setAudioPlayerRef(el, item.id)"
                          :audio-url="item?.fileUrl"
                        />
                      </div>
                      <div class="record-item__medical-content">
                        <div class="record-item__medical-info">
                          <div class="record-item__medical-time">
                            {{ formatDateTime(item.startTime) }}
                          </div>
                          <div class="record-item__medical-duration">
                            拜访时长: {{ formatVisitDuration(item.id) }}
                          </div>
                        </div>
                        <span class="record-item__medical-submit" @click="handleSendRecord(item)"
                          >提交</span
                        >
                      </div>
                    </template>
                    <!-- 普通样式 -->
                    <template v-else>
                      <div @click="handleSendRecordCard(item)">
                        <header class="record-item__header">
                          <h3 class="record-item__title">{{ item.startTime }} 录音</h3>
                          <div class="record-item__actions">
                            <el-button
                              v-if="isQuick"
                              color="#7a52f4"
                              link
                              plain
                              @click.stop="handleSendRecord(item)"
                              >发送</el-button
                            >
                            <el-button
                              color="#969799"
                              link
                              :loading="expireLoading"
                              plain
                              style="margin-left: 0"
                              @click.stop="handleExpireDialog(item.id)"
                            >
                              作废
                            </el-button>
                          </div>
                        </header>
                        <footer class="record-item__footer">
                          <AudioPlayer
                            :ref="(el) => setAudioPlayerRef(el, item.id)"
                            :audio-url="item?.fileUrl"
                            :is-quick="isQuick"
                          />
                        </footer>
                      </div>
                    </template>
                  </li>
                </ul>
                <div v-else class="record-list__empty">
                  暂无待上传<span v-if="isMedicalIndustry">拜访</span><span v-else>录音</span>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-else class="empty">无数据</div>
      </el-tab-pane>
      <!-- 智能贴片 -->
      <el-tab-pane v-else-if="tab.permission" :name="tab.type">
        <template #label>
          {{ tab.label }}
        </template>
        <div class="device-list" :style="{ 'max-height': isMobile() ? '100%' : '320px' }">
          <NveasyBluetoothFileBox
            v-if="tab.type === activeTabName"
            :type="tab.type"
            @send="handleSendNveasyBtRecord"
          ></NveasyBluetoothFileBox>
        </div>
      </el-tab-pane>
    </template>
  </el-tabs>
  <!-- 作废确认弹窗 -->
  <el-dialog
    v-model="expireDialogVisible"
    align-center
    :class="isMobile() ? 'mobile-common-dialog' : 'web-common-dialog'"
    :show-close="!isMobile()"
    title="作废"
    :width="isMobile() ? '80%' : 400"
  >
    <span class="text text-main">作废后该数据不可恢复，确定作废吗？</span>
    <template #footer>
      <template v-if="isMobile()">
        <div class="btn" @click="expireDialogVisible = false">取消</div>
        <div class="btn" @click="setTheRecordExpire">确定</div>
      </template>
      <div v-else class="dialog-footer">
        <el-button @click="expireDialogVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="setTheRecordExpire"> 确定 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import { getRecordList, getRecordExpire } from '@/api'
import { isMobile } from '@/utils'
import AudioPlayer from '@/components/audio-player.vue'
import NveasyBluetoothFileBox from './nveasy-bluetooth/index.vue'
import { useNveasyBluetoothStore } from '@/store/useNveasyBluetoothStore'

const nveasyBluetoothStore = useNveasyBluetoothStore()
const emits = defineEmits(['handleSendRecord', 'handleSendRecordCard'])
const props = defineProps({
  // 设备启用信息
  deviceInfo: {
    type: Object,
    default: () => ({})
  },
  // 是否医疗行业
  isMedicalIndustry: {
    type: Number,
    default: 0
  },
  isQuick: {
    type: Boolean,
    default: true
  }
})

// 存储多个AudioPlayer的ref
const audioPlayerRefs = ref({})
// 弹窗加载中状态
const isLoading = ref(false)
// 作废操作加载状态
const expireLoading = ref(false)
// 作废弹窗显示标记
const expireDialogVisible = ref(false)
// 当前作废的录音ID
const currentExpireRecordId = ref('')
// 激活的tab页名
const activeTabName = ref(1)
// 工牌录音设备列表
const recordingDeviceBadgeList = ref([])
// 挂牌录音设备列表
const recordingDeviceListingList = ref([])
// 工牌录音数目
const recordingBadgeCount = ref(0)
// 挂牌录音数目
const recordingListingCount = ref(0)
// 折叠面板展开状态
const expandedPanels = reactive({})
// 标签页配置列表
const tabList = computed(() => [
  {
    label: '智能胸牌',
    condition: props.deviceInfo.badge === 1, // 显示条件
    list: recordingDeviceBadgeList.value, // 对应数据列表
    recordCount: recordingBadgeCount.value, // 录音数目
    type: 1 // 设备类型
  },
  {
    label: '智能挂牌',
    condition: props.deviceInfo.listing === 1,
    list: recordingDeviceListingList.value,
    recordCount: recordingListingCount.value,
    type: 2
  },
  {
    label: '智能贴片',
    condition: 0,
    permission: nveasyBluetoothStore.isBind,
    list: [],
    recordCount: 0,
    type: 3
  }
])

/**
 * 数据初始化
 */
const init = () => {
  let flag = false
  tabList.value.forEach((tab, index) => {
    if (tab.condition) {
      console.log('❌❌')
      // 仅初始化满足条件的标签页
      getTheRecordList(tab.type)
      if (!flag) {
        activeTabName.value = index + 1
        flag = true
      }
    }
    if (!flag && index === 2 && nveasyBluetoothStore.isBind) {
      activeTabName.value = 3
    }
  })
}
/**
 * 获取录音列表
 * @param type 1: 工牌 2: 挂牌（可选，默认使用activeTabName）
 */
const getTheRecordList = async (type) => {
  isLoading.value = true

  // 优先使用传入的type，否则使用当前激活的tab类型
  const requestType = Number(type || activeTabName.value)
  if (![1, 2].includes(requestType)) {
    console.error('无效的设备类型: ', requestType)
    isLoading.value = false
    return
  }

  try {
    const params = {
      page: 1,
      pageSize: 20,
      type: requestType
    }

    const { result } = await getRecordList(params)

    const recordDeviceList = result?.list || []
    // 计算录音数量
    const totalRecordCount = recordDeviceList.reduce((acc, device) => {
      return acc + (device.recordList?.length || 0)
    }, 0)
    // 根据请求类型更新对应列表
    if (requestType === 1) {
      recordingDeviceBadgeList.value = recordDeviceList
      recordingBadgeCount.value = totalRecordCount
    } else if (requestType === 2) {
      recordingDeviceListingList.value = recordDeviceList
      recordingListingCount.value = totalRecordCount
    }
    // 默认展开当前tab下所有设备的面板
    recordDeviceList.forEach((device) => {
      toggleDevicePanel(requestType, device.deviceNo, true)
    })
  } catch (error) {
    console.error('获取录音列表失败:', error)

    // 错误时清空对应列表，避免展示旧数据
    if (requestType === 1) {
      recordingDeviceBadgeList.value = []
    } else if (requestType === 2) {
      recordingDeviceListingList.value = []
    }
  } finally {
    isLoading.value = false
  }
}
/**
 * 打开作废弹窗的处理
 * @param id 录音id
 */
const handleExpireDialog = (id) => {
  if (!id) {
    console.error('缺失录音ID')
    return
  }

  expireDialogVisible.value = true
  currentExpireRecordId.value = id
}
/**
 * 录音作废
 */
const setTheRecordExpire = async () => {
  expireLoading.value = true

  try {
    await getRecordExpire({ dataId: currentExpireRecordId.value })

    // 刷新当前标签页数据
    getTheRecordList()
  } catch (error) {
    console.error('录音作废失败:', error)
  } finally {
    expireLoading.value = false
    expireDialogVisible.value = false
  }
}
/**
 * 处理录音发送
 * @param recordInfo 录音信息
 */
const handleSendRecord = (recordInfo) => {
  // 获取当前点击的AudioPlayer的ref
  const currentAudioPlayerRef = audioPlayerRefs.value[recordInfo.id]
  if (!currentAudioPlayerRef) {
    console.error('未找到对应的AudioPlayer实例')
    return
  }
  emits('handleSendRecord', recordInfo)
}
/**
 * 处理 nveasy-bluetooth录音发送
 * @param recordInfo 录音信息
 */
const handleSendNveasyBtRecord = (recordInfo) => {
  emits('handleSendRecord', recordInfo)
}
/**
 * 设置AudioPlayer的ref
 * @param el 音频播放器实例
 * @param id 录音id
 */
const setAudioPlayerRef = (el, id) => {
  if (el) {
    audioPlayerRefs.value[id] = el
  }
}

/**
 * @description: 生成设备折叠面板唯一 key
 */
const panelKey = (type, deviceNo) => `${type}-${deviceNo}`
/**
 * @description: 切换指定设备的展开/折叠状态
 * @param type 设备类型
 * @param deviceNo 设备编号
 * @param forceExpand 是否强制展开
 */
const toggleDevicePanel = (type, deviceNo, forceExpand) => {
  if (!deviceNo) return
  const key = panelKey(type, deviceNo)
  if (forceExpand) {
    expandedPanels[key] = true
    return
  }
  expandedPanels[key] = !expandedPanels[key]
}
/**
 * @description: 判断设备面板是否处于展开状态
 */
const isDevicePanelOpen = (type, deviceNo) => {
  if (!deviceNo) return false
  const key = panelKey(type, deviceNo)
  return !!expandedPanels[key]
}
/**
 * @description: 将电量数值格式化为百分比展示
 */
const formatBatteryLevel = (battery) => {
  const value = Number(battery)
  if (Number.isNaN(value)) return '--'
  return `${value}%`
}
/**
 * @description: 判断设备电量是否低电量
 */
const isLowBattery = (data) => {
  return +data <= 20
}

/**
 * @description: 格式化日期时间显示
 * @param dateTime 日期时间字符串
 */
const formatDateTime = (dateTime) => {
  if (!dateTime) return '--'
  // 如果已经是格式化好的字符串，直接返回
  if (typeof dateTime === 'string' && dateTime.includes('-')) {
    return dateTime
  }
  // 如果是时间戳，进行转换
  const date = new Date(dateTime)
  if (isNaN(date.getTime())) return dateTime
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}`
}

/**
 * @description: 格式化拜访时长显示 (时:分:秒)
 * @param recordId 录音ID
 */
const formatVisitDuration = (recordId) => {
  const audioPlayerRef = audioPlayerRefs.value[recordId]
  if (!audioPlayerRef || !audioPlayerRef.numberDuration) {
    return '00:00:00'
  }
  const totalSeconds = Math.floor(audioPlayerRef.numberDuration)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return [hours, minutes, seconds].map((val) => String(val).padStart(2, '0')).join(':')
}

const handleSendRecordCard = (recordInfo) => {
  // 获取当前点击的AudioPlayer的ref
  const currentAudioPlayerRef = audioPlayerRefs.value[recordInfo.id]
  if (!currentAudioPlayerRef) {
    console.error('未找到对应的AudioPlayer实例')
    return
  }
  emits('handleSendRecordCard', recordInfo)
}

onMounted(() => {
  init()
})
</script>

<style lang="scss" scoped>
// 处理滚动问题
:deep(.el-drawer__body) {
  display: flex;
}
:deep(.fr-drawer-center) {
  flex: 1;
}

:deep(.el-tabs__item) {
  height: 34px;
  padding: 14px 16px;
}
:deep(.el-tabs__item:hover) {
  color: #7a52f4 !important;
}
:deep(.el-tabs__active-bar) {
  background-color: #7a52f4 !important;
}
:deep(.el-tabs__nav-wrap:after) {
  background-color: unset !important;
}
:deep(.el-tabs__content) {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  &::-webkit-scrollbar {
    display: none;
  }
}

.device-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  > .device-panel {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.device-panel {
  border-radius: 8px;
  background: #fff;

  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: #f7f8fa;
    cursor: pointer;
    text-align: left;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 336px;

    > * {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #323233;

    > * {
      margin-right: 12px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__label {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #323233;
  }

  &__battery {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-size: 14px;
    color: #323233;

    .t-iconfont {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }

  &__pending {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    letter-spacing: 0em;
    color: #969799;
  }

  &__chevron {
    width: 12px;
    height: 12px;
    border-right: 2px solid #c8cad0;
    border-bottom: 2px solid #c8cad0;
    transform: rotate(-45deg);
    transition: transform 0.2s ease;

    &.is-open {
      transform: rotate(45deg);
    }
  }

  &__body {
    display: grid;
    grid-template-rows: 0fr;
    transition:
      grid-template-rows 0.25s ease,
      opacity 0.25s ease;
    opacity: 0;
  }

  &__body-inner {
    overflow: hidden;
  }

  &__body.is-open {
    grid-template-rows: 1fr;
    opacity: 1;
  }
}

.is-low {
  color: #f54e4e !important;
}

.record-list {
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  margin: 8px 0;

  > .record-item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.record-item {
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  padding: 12px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
  }

  &__duration {
    font-size: 12px;
    color: #969799;
  }

  &__actions {
    display: flex;

    > * {
      margin-right: 12px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__footer {
    height: 34px;
  }

  // 医疗行业特殊样式
  &--medical {
    border: 1px solid #e5e6eb;
    padding: 12px;
    background: #fff;
    position: relative;
  }

  &__medical-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__medical-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  &__medical-time {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 600 !important;
    font-weight: normal;
    line-height: 20px;
    color: #323233;
  }

  &__medical-duration {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: #969799;
  }

  &__medical-submit {
    margin-left: 12px;
    flex-shrink: 0;
    padding: 8px 16px;
    font-size: 14px;
    color: #7a52f4;
    cursor: pointer;
  }
}

.record-list__empty {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  color: #969799;
  font-size: 14px;
}

.text {
  font-family: PingFang SC;
  font-size: 14px;

  &-title {
    font-weight: 600;
    color: #323233;
  }

  &-normal {
    font-weight: normal;
    color: #646566;
  }

  &-main {
    font-weight: normal;
    color: #323233;
  }
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 320px;
  font-size: 14px;
  color: #969799;
}
</style>

<style lang="scss">
.mobile-common-dialog {
  padding: 0;
  border-radius: 12px;
  .el-dialog__header {
    height: 52px;
    line-height: 20px;
    font-size: 14px;
    color: #323233;
    font-weight: 600;
    padding: 24px 24px 8px;
    text-align: center;
    border: none;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    line-height: 20px;
    font-size: 14px;
    color: #323233;
    padding: 0 24px 24px;
    border-bottom: 0.5px solid #e5e6eb;
    text-align: center;
  }
  .el-dialog__footer {
    padding: 0;
    display: flex;
    height: 48px;
    line-height: 48px;
    .btn {
      height: 48px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #7a52f4;
      font-size: 16px;
    }
    .btn:first-child {
      color: #646566;
      border-right: 0.5px solid #e5e6eb;
    }
  }
  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      margin-left: 8px;
      color: #969799;
      font-size: 14px;
    }
  }
}
</style>
